import { Splide } from '@splidejs/splide';
import { Grid } from '@splidejs/splide-extension-grid';
import '@splidejs/splide/css';

const sliders = {
  init() {
    this.prodSlider();
    this.testimonialsSlider();
    this.setProdThumbnailsSlider();
    this.resetSlider();
  },

  resetSlider() {
    window.addEventListener('reset', () => {
      this.setProdThumbnailsSlider();
    });
  },

  prodSlider() {
    const sliders = document.querySelectorAll(
      '.jsProdSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'loop',
        pagination: false,
        arrows: false,
        perPage: 4,
        padding: { right: '1px' },
        breakpoints: {
          1200: {
            pagination: true,
            perPage: 3,
          },
          500: {
            perPage: 1,
          },
        },
      }).mount();
    });
  },

  testimonialsSlider() {
    const sliders = document.querySelectorAll(
      '.jsTestimonialsSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'loop',
        pagination: false,
        arrows: false,
        perPage: 2,
        gap: 40,
        breakpoints: {
          768: {
            perPage: 1,
            grid: {
              rows: 2,
              cols: 1,
              gap: {
                row: 20,
              },
            },
          },
        },
      }).mount({ Grid });
    });
  },

  setProdThumbnailsSlider() {
    const productMainImages = document.getElementById('mainImage') as
      | HTMLElement
      | undefined;


    if (productMainImages) {
      const main = new Splide(productMainImages, {
        type: 'loop',
        pagination: false,
        arrows: false,
        destroy: true,
        breakpoints: {
          1199: {
            pagination: true,
            destroy: false,
            perPage: 1,
            perMove: 1,
          },
        },
      });


      main.mount();

    }
  },

};

export default sliders;
